export default {
  "content": "<path d=\"M14.8 7H3.61L8.5 2.12A1 1 0 008.5.7a1 1 0 00-1.4 0L.5 7.3a1 1 0 000 1.4l6.6 6.6a1 1 0 101.4-1.42L3.62 9H14.8a1 1 0 001-1 1 1 0 00-1-1z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "#333",
    "viewBox": "0 0 16 16"
  }
};